import { render, staticRenderFns } from "./hsArticle.vue?vue&type=template&id=77367564"
import script from "./hsArticle.vue?vue&type=script&lang=js"
export * from "./hsArticle.vue?vue&type=script&lang=js"
import style0 from "./hsArticle.vue?vue&type=style&index=0&id=77367564&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77367564')) {
      api.createRecord('77367564', component.options)
    } else {
      api.reload('77367564', component.options)
    }
    module.hot.accept("./hsArticle.vue?vue&type=template&id=77367564", function () {
      api.rerender('77367564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/hsArticle.vue"
export default component.exports